export default __webpack_public_path__ + "static/media/logo-bw.953107a1.svg";